/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `OPRAVNENY_ZADATEL` - Oprávněný žadatel
 *   * `VLASTNIK_SPRAVCE_PROVOZOVATEL` - Vlastník Správce Provozovatel
 *   * `AZI` - Azi
 *   * `ZADATEL_DLE_ZADOSTI` - Žadatel dle žádosti
 *   * `ORGAN_VEREJNE_MOCI` - Orgán veřejné moci
 *   * `VLASTNIK_DOTCENYCH_NEMOVITOSTI` - Vlastník dotčených nemovitostí
 * ```
 */
export const StatusZadateleEnum = {
  OPRAVNENY_ZADATEL: 'OPRAVNENY_ZADATEL',
  VLASTNIK_SPRAVCE_PROVOZOVATEL: 'VLASTNIK_SPRAVCE_PROVOZOVATEL',
  AZI: 'AZI',
  ZADATEL_DLE_ZADOSTI: 'ZADATEL_DLE_ZADOSTI',
  ORGAN_VEREJNE_MOCI: 'ORGAN_VEREJNE_MOCI',
  VLASTNIK_DOTCENYCH_NEMOVITOSTI: 'VLASTNIK_DOTCENYCH_NEMOVITOSTI',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type StatusZadateleEnum = ValuesOf<typeof StatusZadateleEnum>;

export type StatusZadateleEnumRequest = StatusZadateleEnum;
export type StatusZadateleEnumResponse = StatusZadateleEnum;
